import {IApplicationsStore} from "Stores/Applications/types";
import {inject, observer} from "mobx-react";
import React from "react";
import {FileCopy} from "@material-ui/icons";
import {Values} from "Tools/Values";
import {FullWidthTextField} from "@src/Shared/styles";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import {observable} from "mobx";
import {
    IApplicationInternal,
    IApplicationToken
} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {TokenExpiresText, Loader} from "./styles";
import {IAuthStore} from "Stores/Auth/types";
import {IValuesStore} from "Stores/Values/types";
import RefreshIcon from "@material-ui/icons/Refresh";

interface IProps {
    app: IApplicationInternal
    applicationsStore?: IApplicationsStore;
    onTokenRefresh: (token: IApplicationToken) => void;
    auth?: IAuthStore;
    values?: IValuesStore;
}

@inject("applicationsStore", "auth", "values")
@observer
export class TokenField extends React.Component<IProps> {
    @observable token: string = '';
    @observable expiresAt: string = null;
    @observable isRefreshing: boolean = false;
    @observable buttonContent: JSX.Element = <RefreshIcon/>;

    componentDidMount() {
        this.token = this.props.app.token;
        this.expiresAt = this.removeTimeFromDateString(this.props.app.expiresAt);
    }

    async refreshToken() {
        this.isRefreshing = true;
        const newToken = await this.props.applicationsStore.refreshInternalApplicationToken(this.props.app.clientId);
        this.token = newToken.token;
        this.expiresAt = this.removeTimeFromDateString(newToken.expiresAt);
        this.isRefreshing = false;
        this.buttonContent = <RefreshIcon/>;
        this.props.onTokenRefresh(newToken);
    }

    toggleRefreshButton() {
        this.isRefreshing = true;
        this.buttonContent = <Loader/>;

        setTimeout(() => this.refreshToken(), 300);
    }

    removeTimeFromDateString(str: string) {
        return str.substring(0, 10);
    }

    render() {
        return (
            <>
                <FullWidthTextField
                    name="token"
                    value={this.token}
                    size="small"
                    disabled
                    label={Values.getLocalizationValue('token')}
                    variant="outlined"
                    InputProps={{
                        endAdornment: (
                            <RoundButton
                                icon={<FileCopy/>}
                                tooltipTitle={Values.getLocalizationValue('copy')}
                                onClick={() => {
                                    navigator.clipboard.writeText(this.token)
                                }}
                                color="gray"
                            />
                        )
                    }}
                />

                <div style={{display: 'flex'}}>
                    {this.expiresAt && (
                        <>
                            <TokenExpiresText>
                                {`${Values.getLocalizationValue('expiresAt')} ${this.expiresAt}`}
                            </TokenExpiresText>

                            {this.props.auth.user.roles.find(x => x == this.props.values.roles.Administrator) != null && (
                                <RoundButton
                                    icon={this.buttonContent}
                                    color="gray"
                                    onClick={() => this.toggleRefreshButton()}
                                    tooltipTitle={Values.getLocalizationValue('refresh')}
                                />
                            )}
                        </>
                    )}
                </div>
            </>
        )
    }
}
